import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Card = styled.div`
  width: 50%;
  height: 100vh;
  margin-top: 40px;
`;
export const ContainerLoading = styled.div`
display: flex;
margin-top: 40px;
margin-bottom: 40px;
margin-top: 90px;
justify-content: center;`;

export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  border-radius: 6px;
`;
